<template>
  <div>
    <b-row class="mb-3">
      <b-col cols="12">
        <PageHeader :title="$cte('costs.title')"/>
      </b-col>
    </b-row>
    <b-tabs @input="onTabInput" v-model="activeTab" v-if="!loading" :key="tabsKey">
      <b-tab
          lazy
          title="Számlaösszesítő"
          v-if="showTaxFrequency"
          id="g4"
          active
      >
        <costs-summary :company-id="getActiveCompany.id" :is-inbound="true"/>
      </b-tab>
      <b-tab
          lazy
          :title="$cte('common.uploads')"
      >
        <cost-list />
      </b-tab>
      <b-tab title="NAV" lazy>
        <NavInvoice invoice-direction="INBOUND"/>
      </b-tab>
      <b-tab title="Számlázz.hu" lazy v-if="hasSzamlazzhuKey">
        <AppInvoice direction="INBOUND" source="SZAMLAZZ_HU" :company-id="getActiveCompany.id" />
      </b-tab>
      <b-tab title="Billingo" lazy v-if="hasBillingoKey">
        <AppInvoice direction="INBOUND" source="BILLINGO" :company-id="getActiveCompany.id" />
      </b-tab>
      <b-tab
          lazy
          title="Vámhatározatok"
      >
        <customs :company-id="getActiveCompany.id" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import Api from "api-client";
import PageHeader from "../../../components/PageHeader";
import {mapGetters} from "vuex";
import NavInvoice from "../../../components/NavInvoice";
import CostsSummary from "@/views/app/costs/CostsSummary.vue";
import {
  isEvTaxation,
  getLatestActiveTaxFrequency,
  getLatestCompanyForm,
  getLatestTaxForm
} from "../../../utils/CommonLogic";
import Customs from "@/views/app/costs/Customs.vue";
import AppInvoice from "@/views/app/invoicing/AppInvoice.vue";
import CostList from "@/views/app/costs/CostList.vue";

export default {
  name: "Costs",
  components: {
    CostList,
    AppInvoice,
    Customs,
    CostsSummary,
    PageHeader,
    NavInvoice
  },
  methods: {
    isEvTaxation,
    getLatestActiveTaxFrequency,
    getLatestCompanyForm,
    getLatestTaxForm,
    onTabInput(value) {
      if (!this.visitedTabs.includes(value)) {
        this.visitedTabs.push(value);
      }
    },
    loadCompany() {
      return Api.getCompany(this.getActiveCompany.id).then((resp) => {
        this.company = resp.data;
        let taxFrequency = this.getLatestActiveTaxFrequency(this.company)
        let companyForm = this.getLatestCompanyForm(this.company)
        let taxForm = this.getLatestTaxForm(this.company)

        const isNemAfas = taxFrequency && taxFrequency.type === 'NON_TAX';
        const isRelevantCompanyForm = companyForm && (companyForm === 'PRIMARY_AGRICULTURAL_PRODUCER' ||
            companyForm === 'INDIVIDUAL_WITH_TAX_NUMBER' ||
            companyForm === 'SOLE_PROPRIETORSHIP');
        const isTetelAdozo = taxForm?.form === 'TETELES_ADOZO';

        if (isNemAfas && isRelevantCompanyForm) {
          this.showTaxFrequency = isTetelAdozo;
        } else {
          this.showTaxFrequency = true;
        }

        // if empty (new companies), showing screens
        if ( taxFrequency === null || companyForm === null || taxForm === null) {
          this.showTaxFrequency = true;
        }
      });
    },
    checkApiKeys() {
      if (this.getActiveCompany && this.getActiveCompany.id) {
        const szamlazzhuPromise = Api.getSzamlazzhuKey(this.getActiveCompany.id).then((resp) => {
          if (resp.data && resp.data.key) {
            this.hasSzamlazzhuKey = true;
          }
        }).catch(() => {
          this.hasSzamlazzhuKey = false;
        });

        const billingoPromise = Api.getBillingoToken(this.getActiveCompany.id).then(resp => {
          if (resp.data && resp.data.token) {
            this.hasBillingoKey = true;
          }
        }).catch(() => {
          this.hasBillingoKey = false;
        });

        return Promise.all([szamlazzhuPromise, billingoPromise]);
      }
      return Promise.resolve();
    },
    loadAll() {
      this.loading = true;
      Promise.all([
        this.loadCompany(),
        this.checkApiKeys(),
      ]).finally(() => {
        this.activeTab = 0;
        this.tabsKey++;
        this.loading = false;
      });
    },
  },
  data() {
    return {
      activeTab: 0,
      tabsKey: 0,
      visitedTabs: [],
      showTaxFrequency: false,
      page: 1,
      offset: 3,
      company: {},
      loading: true,
      hasSzamlazzhuKey: false,
      hasBillingoKey: false,
    };
  },
  watch: {
    showTaxFrequency(value) {
      if (value) {
        this.$nextTick(() => {
          this.activeTab = 0;
        });
      }
    },
    getActiveCompany: {
      handler() {
        this.loadAll();
      },
      deep: true,
    }
  },
  created() {
    this.loadAll();
  },
  mounted() {

  },
  computed: {
    ...mapGetters("app", ["getActiveCompany"]),
  },
};
</script>

<style scoped>
* >>> .custom-dropdown > button {
  background-color: transparent;
  color: #80808f !important;
  border: none;
  position: absolute;
  bottom: -17px;
  left: -17px;
}

* >>> .custom-dropdown > button:hover {
  color: #5bb65d !important;
  background-color: transparent;
}

.custom-dropdown {
  width: 95px;
}

</style>
